var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useSession } from '@lendi/lala-react';
import { LendiLDProvider, useFlags } from '@lendi/launchdarkly';
import React, { useState } from 'react';
import { useEmailOpenChat } from '../../hooks/useEmailOpenChat';
import { useCustomerOwner } from '../../hooks/useCustomerOwner';
import { useTeamMember } from '../../hooks/useTeamMember';
import { useUserGroup } from '../../hooks/useUserGroup';
import { checkApplicationScope } from '../../utils';
import { RestrictedTeamViewProvider } from '../RestrictedTeamViewProvider';
import { ChatBootstrapperContext } from './context';
import { useCustomer } from '../../hooks/useCustomer';
import { useStore } from '../../hooks/useStore';
var CustomerChatBootstrapperProviderInner = function (_a) {
    var children = _a.children, broker = _a.broker, store = _a.store, onException = _a.onException, applicationId = _a.applicationId;
    var inputApplicationId = applicationId || checkApplicationScope();
    var _b = useState(false), isCommPanelOpen = _b[0], setCommPanelOpen = _b[1];
    var _c = useState(false), callMeBackClicked = _c[0], setCallMeBackClicked = _c[1];
    var _d = useState(false), isChatOpen = _d[0], setChatOpen = _d[1];
    var _e = useState({
        firstName: '',
        phoneNumber: '',
        email: '',
        otp: '',
    }), chatInputFields = _e[0], setChatInputFields = _e[1];
    var openCommPanel = function () {
        setCommPanelOpen(true);
    };
    var closeCommPanel = function () {
        setCommPanelOpen(false);
    };
    var openChat = function () {
        openCommPanel();
        setChatOpen(true);
    };
    var closeChat = function () {
        setChatOpen(false);
    };
    var session = useSession();
    var _f = useUserGroup('customer', session, onException, undefined, inputApplicationId), channelId = _f.userGroupHash, teamMemberId = _f.teamMemberId, migratedToConversation = _f.channelMigrated, setSelectedThread = _f.setSelectedThread, err = _f.err;
    // get customer details to get owner
    var customer = useCustomer(session, onException);
    var customerOwner = useCustomerOwner(session, customer === null || customer === void 0 ? void 0 : customer.ownerId, onException);
    var teamMemberFromChannel = useTeamMember(session, teamMemberId, onException);
    // use store id to get store name
    var storeName = useStore(session, customer === null || customer === void 0 ? void 0 : customer.storeId, onException);
    useEmailOpenChat(openChat, channelId);
    return (React.createElement(ChatBootstrapperContext.Provider, { value: {
            isCommPanelOpen: isCommPanelOpen,
            openCommPanel: openCommPanel,
            closeCommPanel: closeCommPanel,
            isChatOpen: isChatOpen,
            openChat: openChat,
            closeChat: closeChat,
            teamMember: teamMemberFromChannel,
            customerOwner: customerOwner,
            broker: broker,
            store: store,
            storeName: storeName,
            channelId: channelId,
            migratedToConversation: migratedToConversation,
            setSelectedThread: setSelectedThread,
            applicationId: inputApplicationId,
            errorState: err,
            chatInputFields: chatInputFields,
            setChatInputFields: setChatInputFields,
            callMeBackClicked: callMeBackClicked,
            setCallMeBackClicked: setCallMeBackClicked,
        } }, children));
};
var TeamsChatBootstrapperProviderInner = function (_a) {
    var children = _a.children, onException = _a.onException, customerInfo = _a.customerInfo, applicationId = _a.applicationId;
    var restrictedTeamViewEnabled = useFlags().restrictedTeamViewEnabled;
    var _b = useState(false), isCommPanelOpen = _b[0], setCommPanelOpen = _b[1];
    var _c = useState(false), isChatOpen = _c[0], setChatOpen = _c[1];
    var openCommPanel = function () {
        setCommPanelOpen(true);
    };
    var closeCommPanel = function () {
        setCommPanelOpen(false);
    };
    var openChat = function () {
        openCommPanel();
        setChatOpen(true);
    };
    var closeChat = function () {
        setChatOpen(false);
    };
    var session = useSession();
    var _d = useUserGroup('broker', session, onException, customerInfo, applicationId), channelId = _d.userGroupHash, migratedToConversation = _d.channelMigrated, meAsBrokerMemberOfChannel = _d.meAsBrokerMemberOfChannel, setSelectedThread = _d.setSelectedThread, err = _d.err;
    return (React.createElement(ChatBootstrapperContext.Provider, { value: {
            openChat: openChat,
            closeChat: closeChat,
            isChatOpen: isChatOpen,
            isCommPanelOpen: isCommPanelOpen,
            openCommPanel: openCommPanel,
            closeCommPanel: closeCommPanel,
            channelId: channelId,
            migratedToConversation: migratedToConversation,
            setSelectedThread: setSelectedThread,
            applicationId: applicationId,
            errorState: err,
        } },
        React.createElement(RestrictedTeamViewProvider, { viewEnabled: restrictedTeamViewEnabled, meAsBrokerMemberOfChannel: meAsBrokerMemberOfChannel, channelId: channelId, onException: onException }, children)));
};
// TODO: Merge CustomerChatBootstrapperProvider and TeamsChatBootstrapperProvider into one
export var CustomerChatBootstrapperProvider = function (props) {
    return (React.createElement(LendiLDProvider, null,
        React.createElement(CustomerChatBootstrapperProviderInner, __assign({}, props))));
};
// TODO: Merge CustomerChatBootstrapperProvider and TeamsChatBootstrapperProvider into one
export var TeamsChatBootstrapperProvider = function (props) { return (React.createElement(LendiLDProvider, null,
    React.createElement(TeamsChatBootstrapperProviderInner, __assign({}, props)))); };
//# sourceMappingURL=provider.js.map